import system from "@/axios/service/service";

const prepareConfig = (params, vueInstance, file) => {
  return system
    .uploadFile(params)
    .then(res => {
      if (res.respCode == 100) {
        let config = res.data;

        vueInstance.fileBasePath = config.downloadUrl;
        vueInstance.action = config.uploadUrl;
        vueInstance.data = config.uploadFormDto;
        file.downloadUrl = config.downloadUrl;
        Promise.resolve();
      } else {
        Promise.reject();
      }
    })
    .catch(err => {
      vueInstance.$message.error("上传失败");
      Promise.reject();
    });
};

export default {
  prepareConfig
};
